import React from 'react';
import SavedCardsDropdown from 'components/pages/checkout/payment/saved_cards/saved_cards_dropdown';
import SelectedSavedCard from 'components/pages/checkout/payment/saved_cards/selected_saved_card';
import { useSavedCards } from 'components/pages/checkout/hooks/use_saved_cards';
import { useOrderDetails } from 'components/context/order_details';
import { STORE_CODES } from 'constants/enums';
import { onCheckoutPageClick } from 'components/pages/checkout/utilities';
import { COMPONENT_NAMES } from 'constants/tracking';

const allowPostalCode = (selectedCard, storeCode) => {
  if (selectedCard === null) {
    return false;
  }

  if (!selectedCard?.payment_source?.postal_code?.trim()) {
    return false;
  }

  return storeCode === STORE_CODES.US;
};

const SavedCardsContainer = ({
  dropdownTopPosition = 0,
  dropdownLeftPosition = 0,
  setShowCardForm,
  sqCard,
  canUseSavedCard,
  selectedCard,
  setSelectedCard,
}) => {
  if (!canUseSavedCard) {
    return null;
  }

  const { store, trackingData } = useOrderDetails();
  const {
    showSavedCards,
    savedCards,
    savedCardsDropdownRef,
    deletionInProgress,
    handlers,
  } = useSavedCards(
    setShowCardForm,
    sqCard,
    canUseSavedCard,
    setSelectedCard,
    onCheckoutPageClick,
  );

  return (
    <>
      <SelectedSavedCard
        selectedCard={selectedCard}
        usePostalCode={allowPostalCode(selectedCard, store)}
        onCardClicked={(event) => {
          handlers.onCardClicked(event);
          onCheckoutPageClick({
            eventDesc: 'Click selected saved card',
            componentName: COMPONENT_NAMES.APPS.CHECKOUT.PAYMENT_INFO,
            actionItem: 'click_selected_saved_card',
            trackingData,
          });
        }}
      />
      <div ref={savedCardsDropdownRef}>
        <SavedCardsDropdown
          topPosition={dropdownTopPosition}
          leftPosition={dropdownLeftPosition}
          open={showSavedCards}
          deletionInProgress={deletionInProgress}
          savedCards={savedCards}
          onCardSelected={(event) => {
            handlers.onCardSelected(event);
            onCheckoutPageClick({
              eventDesc: 'Select saved card',
              componentName: COMPONENT_NAMES.APPS.CHECKOUT.PAYMENT_INFO,
              actionItem: 'select_saved_card',
              trackingData,
            });
          }}
          onCardDeleted={(event) => {
            handlers.onCardDeleted(event);
            onCheckoutPageClick({
              eventDesc: 'Delete saved card',
              componentName: COMPONENT_NAMES.APPS.CHECKOUT.PAYMENT_INFO,
              actionItem: 'delete_saved_card',
              trackingData,
            });
          }}
        />
      </div>
    </>
  );
};

export default SavedCardsContainer;
